<p>osm-map-one works!</p>
